import { render, staticRenderFns } from "./inpatients.vue?vue&type=template&id=bcb70a32"
import script from "./inpatients.vue?vue&type=script&lang=js"
export * from "./inpatients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports